export default "__VITE_ASSET__UhKOh8ob__"